import { OffersAsyncActions } from 'store/actions/offers';
import { createReducerFromActions } from 'utils/store';
import { values } from 'lodash';

export default createReducerFromActions(...values(OffersAsyncActions));
